import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { defineMessages, useIntl } from 'react-intl';
import prettyBytes from 'pretty-bytes';
import { useFormikContext } from 'formik';

const messages = defineMessages({
  dropFiles: {
    id: 'fileselector.drag-and-drop-message',
    defaultMessage: 'Drag and drop some files here, or click to select files',
  },
  import: { id: 'actions.import', defaultMessage: 'Import' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
});

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

/**
 * Renders a Dropzone and allows the user to select a file.
 * Expects
 * - intl
 * - onUpload(files)
 * - onCancel
 * @param {*} props
 */
const FileDropzone = (props) => {
  const { formatMessage, locale } = useIntl();
  const { setFieldValue } = useFormikContext();

  const { acceptedFiles, getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop: (files) => {
      setFieldValue('file', files[0]);
    },
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragAccept, isDragReject],
  );

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path}
      {' - '}
      {prettyBytes(file.size, { locale })}
    </li>
  ));

  return (
    <section className="container">
      <div {...getRootProps({ className: 'dropzone' })} style={style}>
        <input {...getInputProps()} />
        <p>{formatMessage(messages.dropFiles)}</p>
      </div>
      <aside>
        <ul>{files}</ul>
      </aside>
    </section>
  );
};

export default FileDropzone;
